/**
 * Context Definitions — Persona-based contexts for the GRC client portal
 * Each context represents a role within the client organization
 * Pattern: Immobilia PRO style (Acheteur, Vendeur, Proprietaire...)
 */

import type { ContextMeta } from '@/types/real-estate'

export const CONTEXTS: ContextMeta[] = [
  {
    id: 'dirigeant',
    label: 'Dirigeant',
    description: 'Vision strategique, KPIs, board',
    icon: 'Crown',
    color: 'amber',
    dashboardRoute: '/dashboard',
  },
  {
    id: 'ciso',
    label: 'CISO',
    description: 'Securite, incidents, controles',
    icon: 'Shield',
    color: 'red',
    dashboardRoute: '/dashboard',
  },
  {
    id: 'dpo',
    label: 'DPO',
    description: 'Vie privee, RGPD, Loi 25, consentements',
    icon: 'Eye',
    color: 'violet',
    dashboardRoute: '/compliance',
  },
  {
    id: 'risk-manager',
    label: 'Risk Manager',
    description: 'Registre risques, traitement, KRI',
    icon: 'AlertTriangle',
    color: 'orange',
    dashboardRoute: '/risks',
  },
  {
    id: 'compliance-officer',
    label: 'Compliance Officer',
    description: 'Multi-reglementaire, gap analysis, audits',
    icon: 'Scale',
    color: 'teal',
    dashboardRoute: '/compliance',
  },
  {
    id: 'data-ia-officer',
    label: 'Data & IA Officer',
    description: 'Donnees, qualite, IA responsable',
    icon: 'Database',
    color: 'purple',
    dashboardRoute: '/data-pro',
  },
  {
    id: 'collaborateur',
    label: 'Collaborateur',
    description: 'Mes taches, evaluations, signalements',
    icon: 'Users',
    color: 'blue',
    dashboardRoute: '/dashboard',
  },
  {
    id: 'administration',
    label: 'Administration',
    description: 'Equipe, prestataires, facturation',
    icon: 'Settings',
    color: 'slate',
    dashboardRoute: '/admin/users',
  },
]

/** Quick lookup by context ID */
export const CONTEXT_MAP = Object.fromEntries(CONTEXTS.map((c) => [c.id, c])) as Record<string, ContextMeta>
